import React from 'react';
import { Destination } from './Destination';

interface DestinationsNavProps
	{
	destinations: Destination[];
	activeIndex: number | null;
	hasIntro: boolean;
	}

// Frontend-only (index.tsx) -- the editor canvas now shows the real render.php
// output via ServerSideRender instead of re-implementing this markup.
//
// When `hasIntro`, the first entry is the generic "default" tab (shown before
// a destination is picked) -- same data shape as the rest, just styled as the
// panel's header row instead of a selectable item (no divider, no dot).
// Single-location pages/contexts have no intro, so every item is a normal row.
export const DestinationsNav = ({ destinations, activeIndex, hasIntro }: DestinationsNavProps) =>
	{
	return (
		<nav className="wp-block-ocean-destinations__nav">
			<ul className="wp-block-ocean-destinations__nav-list">
				{destinations.map((destination, index) =>
					{
					const isDefault = hasIntro && index === 0;
					const isActive = index === activeIndex;
					const itemClassName = [
						'wp-block-ocean-destinations__nav-item',
						isDefault ? 'is-default' : '',
						isActive ? 'is-active' : '',
						].filter(Boolean).join(' ');

					return (
						<li key={index} className={itemClassName}>
							<span className="wp-block-ocean-destinations__nav-label">
								{destination.name}
							</span>
							{isActive && !isDefault && <span className="wp-block-ocean-destinations__nav-dot" aria-hidden="true" />}
						</li>
						);
					})}
			</ul>
		</nav>
		);
	};
